import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

interface RoleProtectedRouteProps {
  allowedRoles: string[];
  redirectPath?: string;
  children?: React.ReactNode;
}

const RoleProtectedRoute = ({ 
  allowedRoles, 
  redirectPath,
  children 
}: RoleProtectedRouteProps) => {
  const { user, isLoading, isAuthenticated } = useAuth();

  if (isLoading) {
    return <>{children}</>;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  const userRole = user?.role?.toLowerCase() || "student";
  
  if (!userRole || !allowedRoles.includes(userRole)) {
    const redirect = redirectPath || `/dashboard/${userRole}`;
    return <Navigate to={redirect} replace />;
  }

  return <>{children}</>;
};

export default RoleProtectedRoute;
